
import { Component, Mixins, ActionButtonConfig, FormModalMixins} from "@/lib";
import Role from "@/store/modules/system/role/entity";
@Component
export default class EditRole extends Mixins(FormModalMixins) {
    model = new Role();
    created(){
        Object.assign(this.config, { modelTitleL: "Action.Edit",labelWidth:100, okAction:"system/role/update"});
    }
    get record(){
        return this.$store.state.system.role.editRole;
    }
}
